import { iconoDoc } from '../core/componentes.js';
import { usuarioDe } from '../core/dominio.js';
import { S } from '../core/estado.js';
import { esc, fecha, peso } from '../core/formato.js';
import { db } from '../data/db.js';

/* =====================================================================
   DOCUMENTACIÓN
   ===================================================================== */
export function tabDocumentacion(cid){
  // Los documentos colgados de un pedido se ven y gestionan desde ese
  // pedido, no aquí, para no mezclar la documentación general del contrato
  // con los albaranes de cada pedido concreto.
  const todos = db.documentos.filter(d=>d.contrato===cid && !d.pedido);
  let docs = todos.slice().sort((a,b)=>b.fecha.localeCompare(a.fecha));
  if(S.tipoDoc!=='todos') docs = docs.filter(d=>d.tipo===S.tipoDoc);
  const tipos = [...new Set(todos.map(d=>d.tipo))];
  const total = todos.reduce((s,d)=>s+d.tam,0);
  const puede = S.usuario.rol!=='consulta';
  const puedeBorrar = d => S.usuario.rol==='admin' || d.usuario===S.usuario.id;
  return `
  ${puede?`<div class="card card-b" style="margin-bottom:16px">
    <div class="dropzone" data-act="subir" data-c="${cid}"
         ondragover="event.preventDefault();this.classList.add('activa')"
         ondragleave="this.classList.remove('activa')"
         ondrop="soltarFicheros(event, ${cid})">
      <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="var(--verde)" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" style="margin-bottom:8px"><path d="M12 16V4M8 8l4-4 4 4M4 16v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-3"/></svg>
      <h4>Arrastra aquí albaranes, partes de trabajo o fotos</h4>
      <p>O pulsa para elegirlos. PDF, JPG, PNG, Word y Excel · hasta 20 MB por fichero.</p>
    </div></div>`:''}
  <div style="display:flex;gap:7px;margin-bottom:16px;flex-wrap:wrap;align-items:center">
    <button class="btn btn-s ${S.tipoDoc==='todos'?'btn-d':''}" data-act="filtro-doc" data-f="todos">Todos</button>
    ${tipos.map(t=>`<button class="btn btn-s ${S.tipoDoc===t?'btn-d':''}" data-act="filtro-doc" data-f="${esc(t)}">${esc(t)}</button>`).join('')}
    <span style="margin-left:auto;color:var(--gris-claro);font-size:12px">${todos.length} documentos · ${peso(total)}</span>
  </div>
  ${docs.length?`<div class="docs">${docs.map(d=>`
    <div class="doc">
      <div class="prev">${iconoDoc(d.tipo)}</div>
      <div class="meta"><div class="nom">${esc(d.nombre)}</div>
        <div class="sub">${fecha(d.fecha)} · ${peso(d.tam)}</div>
        <div class="sub">${esc(usuarioDe(d.usuario)?.nombre||'—')}</div></div>
      <div class="pie"><span class="tag t-borrador">${esc(d.tipo)}</span>
        <button class="btn btn-x" data-act="ver-doc" data-id="${d.id}">Ver</button>
        <button class="btn btn-x" data-act="descargar-doc" data-id="${d.id}">Descargar</button>
        ${puedeBorrar(d)?`<button class="btn btn-x btn-peligro" data-act="confirmar-borrar-doc" data-id="${d.id}">Borrar</button>`:''}</div>
    </div>`).join('')}</div>`
  :`<div class="card vacio"><h4>Todavía no hay documentos</h4><p>${puede?'Sube el primer albarán o parte de trabajo desde el recuadro de arriba.':'Cuando alguien suba documentación aparecerá aquí.'}</p></div>`}`;
}

